import { createAction } from '@reduxjs/toolkit';
import { IScheduledValue } from '../../../../dto';
import { ACT_SET, TYPE_LIST, MN_SCHEDULED_VALUES } from '../../../../common';

export const setScheduledValues = createAction<IScheduledValue[]>(
  `${MN_SCHEDULED_VALUES}/${TYPE_LIST}/${ACT_SET}`,
);
